import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';

class VisualErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(`[VisualErrorBoundary] Caught error:`, error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    if (this.props.onRetry) {
      this.props.onRetry();
    } else {
        // Default to window reload if no specific retry provided
        window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <Paper
          elevation={0}
          sx={{
            p: 4,
            m: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            bgcolor: 'rgba(244, 63, 94, 0.04)',
            border: '1px dashed rgba(244, 63, 94, 0.3)',
            borderRadius: 4,
            minHeight: 200,
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 48, color: '#f43f5e', mb: 2, opacity: 0.8 }} />
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#f43f5e', mb: 1 }}>
            Visualization Error
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3, maxWidth: 400 }}>
            Something went wrong while rendering this section. This can happen with incompatible data formats in history.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="outlined"
              size="small"
              startIcon={<RefreshIcon />}
              onClick={this.handleRetry}
              sx={{
                color: '#f43f5e',
                borderColor: 'rgba(244, 63, 94, 0.5)',
                '&:hover': {
                  borderColor: '#f43f5e',
                  bgcolor: 'rgba(244, 63, 94, 0.08)',
                },
              }}
            >
              Retry Rendering
            </Button>
            {this.props.showReset && (
                <Button 
                    variant="text" 
                    size="small"
                    onClick={() => {
                        localStorage.removeItem('aiinsight_last_session_id');
                        window.location.reload();
                    }}
                    sx={{ color: 'text.secondary' }}
                >
                    Reset Session
                </Button>
            )}
          </Box>
        </Paper>
      );
    }

    return this.props.children;
  }
}

export default VisualErrorBoundary;
